import styled from 'styled-components';
import colors from '../../../helpers/colors';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid } from '../../Grid';

export const FooterWrapper = styled.div`
  // stretch to full width
  margin: 0 calc(50% - 50vw);
  // restore width of content
  padding: 0 calc(50vw - 50%);
  background: ${colors.neutral07};
  border-top: solid 1px ${colors.neutral04};
`;

export const StyledGrid = styled(Grid)`
  padding-top: ${spacing(4)};
  ${mediaQuery.tabletPortrait`
    padding-top: ${spacing(7)};
  `}
`;
